export default __webpack_public_path__ + "static/media/unsplash.83511179.webp";